
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Création de site Internet one page : pour qui et pour quoi ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Petit budget de communication ou besoin d’une vitrine digitale simple et efficace ? Et si la création d’un site Web one page était la solution ?",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Création de site Internet one page : pour qui et pour quoi ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Petit budget de communication ou besoin d’une vitrine digitale simple et efficace ? Et si la création d’un site Web one page était la solution ?",
        },
      ],
    };
  },
};
